export default __webpack_public_path__ + "static/media/My Portfolio.d0841b03.png";